import axios from 'axios';
import { safeLocalStorage } from '@utils/localstorage';

const axiosBaseApi = axios.create({
	baseURL: process.env.NEXT_PUBLIC_API_URL,
	headers: {
		'Content-Type': 'application/json'
	}
});

axiosBaseApi.interceptors.request.use((config) => {
	const token = safeLocalStorage.getItem('authToken');
	config.headers.Authorization = token ? `Bearer ${token}` : '';
	return config;
});

axiosBaseApi.interceptors.response.use(
	(response) => {
		if (response.status >= 200 && response.status < 300) {
			return response?.data;
		}
	},
	(error) => {
		if (error?.response?.data) {
			return error.response.data;
		}
		// Network error or no response data
		console.error('API error:', error?.message);
		return null;
	}
);

export default axiosBaseApi;
